// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-northeast-1",
    "aws_cognito_identity_pool_id": "ap-northeast-1:347c4944-9a58-49e8-a7dc-1cef42f4b46a",
    "aws_cognito_region": "ap-northeast-1",
    "aws_user_pools_id": "ap-northeast-1_tLFgIMYrr",
    "aws_user_pools_web_client_id": "28hvj9g1lpad6oavk88jomg6mj",
    "oauth": {},
    "aws_appsync_graphqlEndpoint": "https://xit7ced6ozaprhuzefysjo2pgq.appsync-api.ap-northeast-1.amazonaws.com/graphql",
    "aws_appsync_region": "ap-northeast-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-jon6e4nxdjcurcnf46tr5m45nq"
};


export default awsmobile;
